import * as THREE from "three";
import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Floor from "./Floor.js";
import Walls from "./Walls.js";
import InteractionManager from "./Objects/managers/InteractionManager.js";
import SaveRoom from "./SaveRoom.js";

export default class Room {
  constructor(_shape, _measureWalls, _texturesWalls, _textureFloor) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.objectManager = this.experience.objectManager;

    this.shape = _shape;
    this.measureWalls = _measureWalls;
    this.texturesWalls = _texturesWalls;
    this.textureFloor = _textureFloor;

    this.saveRoom = new SaveRoom(
      this.shape,
      this.measureWalls,
      this.objectManager.getSaveInfosObjects(),
      this.texturesWalls,
      this.textureFloor
    );

    this.heightWalls = 2.5;

    this.initialize();
  }

  initialize() {
    return new Promise((resolve) => {
      this.resources.on("ready", () => {
        this.setupRoom();
        this.objectManager.setRoom(this);
        resolve(this); // Résout la promesse avec l'instance de la salle
      });
    });
  }

  setupRoom() {
    this.walls = new Walls(this.texturesWalls);
    this.floor = new Floor(this.textureFloor);

    /* this.objectManager.createObject("wc", {
      modelPath: "./models/wc.glb",
      position: new THREE.Vector3(-0.2, 0, 0.05),
      id: "wc_001",
    });

    this.objectManager.createObject("wc", {
      modelPath: "./models/wc.glb",
      position: new THREE.Vector3(-0.2, 0, 2),
      id: "wc_002",
    });


    this.objectManager.createObject("furniture", {
      modelPath: "./models/furniture.glb",
      position: new THREE.Vector3(-0.6, 0, -0.6),
      id: "furniture_001",
    });


    this.objectManager.createObject("washBasin", {
      modelPath: "./models/vasque2.glb",
      position: new THREE.Vector3(-0.2, 0, -2.9),
      id: "vasque_001",
    });

    this.objectManager.createObject("partition", {
      scale: [1,1,1],
      position: { x: -0.4, y: 0, z: 0 }
    });
    
    this.objectManager.createObject("pipeBoxing", {
      scale: [0.7, 1, 0.5],
      position: { x: 1.55, y: 0, z: -2.7 }    
    });

    this.objectManager.createObject("showerPanel", {
      scale: [2,1,1],
      position: { x: 0, y: 0, z: 2.95 },
      srcTexture: "./textures/sol4.jpg"
    }); 
 */
  
    this.environment = new Environment();
    this.interactionManager = new InteractionManager();
  }

  /**
   * Export JSON file
   */
  exportJSON() {
    this.saveRoom.exportJSON();
  }

  update() {
    if (this.walls) {
      this.walls.update();
    }
    if (this.interactionManager) {
      this.interactionManager.update();
    }
  }

  removeObject() {
    if (this.interactionManager) {
      this.interactionManager.removeObject();
    }
  }

  duplicateObject() {
    if (this.interactionManager) {
      this.interactionManager.duplicateObject();
    }
  }

  onPointerDown(event) {
    if (this.interactionManager) {
      this.interactionManager.onPointerDown(event);
    }
    if (this.walls) {
      this.walls.onPointerDown(event);
    }
  }

  onPointerUp(event) {
    if (this.interactionManager) {
      this.interactionManager.onPointerUp(event);
    }

    if (this.walls) {
      this.walls.onPointerUp(event);
    }
  }

  /**
   * Functions for walls
   */
  getWallSegments() {
    if (this.walls) {
      return this.walls.getWallSegments();
    }
  }

  getWallsGroupPosition() {
    if (this.walls) {
      return this.walls.getWallsGroupPosition();
    }
  }

  getWallsGroup() {
    if (this.walls) {
      return this.walls.getWallsGroup();
    }
  }

  /**
   * Function for objects
   */
  detachSelectedObject() {
    this.interactionManager.detachSelectedObject();
  }

  detachSelectedWall() {
    this.walls.detachSelectedWall();
  }

  getIsSelectedObject() {
    if (this.interactionManager) {
      return this.interactionManager.getIsSelectedObject();
    } else {
      return false;
    }
  }

  getSelectedObject() {
    if (this.interactionManager) {
      return this.interactionManager.getSelectedObject();
    } else {
      return null;
    }
  }

  setSelectedObject(newSelectedObject) {
    if (this.interactionManager) {
      return this.interactionManager.setSelectedObject(newSelectedObject);
    } else {
      return null;
    }
  }


  getIsSelectedWall() {
    if (this.walls) {
      return this.walls.getIsSelectedWall();
    } else {
      return false;
    }
  }

  setSelectedWall(value) {
    if (this.walls) {
      this.walls.setSelectedWall(value);
    }
  }

  deleteWalls() {
    if(this.walls) {
      this.walls.deleteWalls();
      
    }
  }

  createWalls(sizesWalls, shapeType) {
    
    this.shape = shapeType;
    this.measureWalls = sizesWalls;
   
    this.saveRoom.setDataRoom(this.measureWalls, this.shape);
    
    if(this.walls) {
      this.walls.createWalls(sizesWalls, 2.5, shapeType);
      
    }
  }

  deleteFloor() {
    if(this.floor) {
      this.floor.deleteFloor();
    }
  }


  createFloor() {
    if(this.floor) {
      this.floor.initialize();
    }
  }

  getWallThickness(){
    if(this.walls){
      return this.walls.getWallThickness();
    }
  }
  
}
